import { forwardRef } from 'react';

import { ValidableSection } from '@/policy/component/Validation/ValidableSection';
import { useScroll } from '@/policy/hooks/useScroll';
import { Amendment } from '@/policy/types/PolicyCoverage';
import { ValidationResult } from '@/policy/types/ValidationResult';

import { ScrollShadows } from '../ScrollShadows/ScrollShadows';
interface AmendmentSectionProps {
  section: Amendment;
  validation: ValidationResult;
  onValidationChange: (validation: ValidationResult) => void;
  isSelected: boolean;
  onTableClick: (sectionUuid: string) => void;
}

export const AmendmentSection = forwardRef<
  HTMLDivElement,
  AmendmentSectionProps
>(
  (
    { section, validation, onValidationChange, isSelected, onTableClick },
    ref,
  ) => {
    const { scrollContainerRef, dragProps, canScrollLeft, canScrollRight } =
      useScroll();

    return (
      <ValidableSection
        ref={ref}
        title={section.title}
        sectionIdentifier={section.identifier}
        validation={validation}
        onValidationChange={onValidationChange}
        isSelected={isSelected}
        onTableClick={onTableClick}
      >
        <ScrollShadows
          canScrollLeft={canScrollLeft}
          canScrollRight={canScrollRight}
        >
          <div
            ref={scrollContainerRef}
            {...dragProps}
            className="whitespace-pre-line text-xxs w-full overflow-x-auto scrollbar-visible px-[32px] py-[8px]"
          >
            {section.description.replace(/\\n/g, '\n')}
          </div>
        </ScrollShadows>
      </ValidableSection>
    );
  },
);

AmendmentSection.displayName = 'AmendmentSection';
